module.exports = __webpack_public_path__ + "static/media/tutorial4.deeb4f24.png";